import {
  GET_TOPBAR_BEGIN,
  GET_TOPBAR_SUCCESS,
  GET_TOPBAR_FAIL
} from '../action/topbarAction'

const initialState = {
  loading: false,
  topbars: null,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TOPBAR_BEGIN:
      return {
        loading: true,
        error: null
      }
    case GET_TOPBAR_SUCCESS:
      return {
        loading: false,
        topbars: action.payload.data
      }
    case GET_TOPBAR_FAIL:
      return {
        loading: false,
        error: action.payload.error.response.data
      }
    default:
      return state
  }
}